
// import { getStorage } from "../../utils/storage"; // Import token storage function

import { data } from "jquery";
import TaskManagerRequest from "../../services/TaskManagerRequest";
import { getStorage } from "../../services/localStorageService";
export const CREATE_NEW_RIDE = 'CREATE_NEW_RIDE'
export const FETCH_RIDES = "FETCH_RIDES";
export const CREATE_NEW_PICKDROP = 'CREATE_NEW_PICKDROP'
export const FETCH_PICKDROP = "FETCH_PICKDROP";
export const SET_TIME = "SET_TIME";
export const UPDATE_STATUS_RESERVE = "UPDATE_STATUS_RESERVE";
export const UPDATE_STATUS_PICKDROP = "UPDATE_STATUS_PICKDROP";
export const SET_ASSIGNMENT_STATUS = "SET_ASSIGNMENT_STATUS";
export const SET_ACTIVE_DRIVER = "SET_ACTIVE_DRIVER";
export const UPDATE_RIDES = "UPDATE_RIDES";
export const FETCH_TIMELINE = "FETCH_TIMELINE";
export const SET_FLEET_RESERVE_TAB_INDEX = "SET_FLEET_RESERVE_TAB_INDEX";
export const UPDATE_DRIVER_PICKDROP = "UPDATE_DRIVER_PICKDROP";
export const UPDATE_DRIVER_RESERVE = "UPDATE_DRIVER_RESERVE";
export const OPTIMIZE_RESERVATIONS = "OPTIMIZE_RESERVATIONS";
export const APPLY_OPTIMIZE_RESERVATIONS = "APPLY_OPTIMIZE_RESERVATIONS";
export const FLEET_GET_CUSTOMER_LIST = "FLEET_GET_CUSTOMER_LIST";



export const createNewReservation = (data) => {
    return async (dispatch) => {
        
            // Get token from storage
            const token = getStorage('__token__');
            data['X-CSRF-TOKEN'] = token; // Attach token

            // Send POST request
            const response = await TaskManagerRequest(`/fleet/createNewReservation`, data);

            // Dispatch action with response data
         

            return response; // Optional: Return response for further handling in the component
        } 
    
};

export const fetchReservations = (filters) => {
  return async (dispatch) => {
    try {
      // Get token from storage
      const token = getStorage("__token__");
      const { driver, startDate, endDate, assignmentStatus, group,createdByRole } = filters;
      
      // Send GET request with all parameters including assignment status
      const response = await TaskManagerRequest(`/fleet/getAllReservations`, {
        driver, 
        startDate, 
        endDate,
        assignmentStatus ,
        group,createdByRole
      });
      
      const sortedData = response.data.sort((a, b) => {
        const posA = a.orderPosition ?? 0;
        const posB = b.orderPosition ?? 0;
        return posA - posB;
      });
      
      // Dispatch action with response data
      dispatch({
        type: FETCH_RIDES,
        value: sortedData,
      });
      
      return response;
    } catch (error) {
      console.error("Error fetching rides:", error);
      throw error;
    }
  };
};
export const fetchTimeline = () => {
  return async (dispatch) => {
    try {
      // Get token (if required, you can remove this if not needed)
      const token = getStorage("__token__");

      // Prepare formatted date with timezone adjustment
      

      // Send POST request with date payload
      const timelineResponse = await TaskManagerRequest("/fleet/timeline", {});

      // Dispatch the result to the store
      dispatch({
        type: FETCH_TIMELINE,
        value: timelineResponse.data,
      });

      return timelineResponse;
    } catch (error) {
      console.error("Error fetching timeline:", error);
      throw error;
    }
  };
};
export const setFleetReserveTabIndex = (value) => {
  try {
    return async (dispatch) => {
      dispatch({
        type: SET_FLEET_RESERVE_TAB_INDEX,
        value: value,
      });
    };
  } catch (error) {
    console.log("Error setting tab index:", error);
    return false;
  }
};



export const createNewPickDrop = (data) => {
    return async (dispatch) => {
        
            // Get token from storage
            const token = getStorage('__token__');
            data['X-CSRF-TOKEN'] = token; // Attach token

            // Send POST request
            const response = await TaskManagerRequest(`/fleet/createPickDrop`, data);

            // Dispatch action with response data
            // dispatch({
            //     type: CREATE_NEW_PICKDROP,
            //     value: response,
            // });

            return response; // Optional: Return response for further handling in the component
        } 
    
};
export const fetchPickDrop = (filters) => {
  return async (dispatch) => {
    try {
      const token = getStorage("__token__");
      const { driver, startDate, endDate,assignmentStatus, group } = filters;

      const response = await TaskManagerRequest(`/fleet/getAllPickDrop`, 
        
         { driver, startDate, endDate,assignmentStatus,group });

      const sortedData = response.data.sort((a, b) => {
        const posA = a.orderPosition ?? 0;
        const posB = b.orderPosition ?? 0;
        return posA - posB;
      });

      dispatch({
        type: FETCH_PICKDROP,
        value: sortedData,
      });

      return { ...response, data: sortedData };
    } catch (error) {
      console.error("Error fetching pick/drop:", error);
      throw error;
    }
  };
};


export const setTimetoGetFleetReserve = (value) => {
  try {
    return async (dispatch) => {
      dispatch({
        type: SET_TIME,
        value: value,
      });
    };
  } catch (error) {
    console.log("Error : ", error);
    return false;
  }
};
export const updateStatusReserve = (id, status, driver) => {
  return async (dispatch) => {
    try {
      const token = getStorage("__token__");

      const response = await TaskManagerRequest(
        `/fleet/updateStatusReserve/${id}`,
        {
          status,
          driver, // 👈 include driver in the request payload
        }
      );

      console.log("Update response:", response.data);

      dispatch({
        type: UPDATE_STATUS_RESERVE,
        value: response.data,
      });

      return response;
    } catch (error) {
      console.error("Error updating status:", error);
      throw error;
    }
  };
};

export const updateStatusPickDrop = (id, status, driver) => {
    return async (dispatch) => {
      try {
        const token = getStorage("__token__");
  
        const response = await TaskManagerRequest(`/fleet/updateStatusPickDrop/${id}`, { status, driver });

        // Optionally you can dispatch a success message or loader action here
        console.log("Update response:", response.data);
  
        dispatch({
            type: UPDATE_STATUS_PICKDROP,
            value: response.data,
        });

  
        return response;
      } catch (error) {
        console.error("Error updating  status:", error);
        throw error;
      }
    };
  };


export const AssignmentStatus = (status) => ({
    type: SET_ASSIGNMENT_STATUS,
    value: status,
  });
  
  export const SetActiveDriver = (driverId) => ({
    type: SET_ACTIVE_DRIVER,
    value: driverId,
  });
  


  export const updateRides = (filteredRides) => {
    return (dispatch) => {
      try {
        dispatch({
          type: UPDATE_RIDES,
          value: filteredRides,
        });
      } catch (error) {
        console.error("Error updating rides:", error);
        throw error;
      }
    };
  };
  export const updateDriverAssignment = (id, driver) => {
    return async (dispatch) => {
      try {
        const token = getStorage("__token__");
  
        const response = await TaskManagerRequest(
          `/fleet/updateDriverAssignment/${id}`,
          { driver }
        );
  
        console.log("Driver update response:", response.data);
  
        dispatch({
          type: UPDATE_DRIVER_PICKDROP, // <-- Define this action type in your reducer
          value: response.data,
        });
  
        return response;
      } catch (error) {
        console.error("Error updating driver:", error);
        throw error;
      }
    };
  };
  export const updateReserveAssignment = (id, driver) => {
    return async (dispatch) => {
      try {
        const token = getStorage("__token__");
  
        const response = await TaskManagerRequest(
          `/fleet/updateReserveAssignment/${id}`,
          { driver }
        );
  
        console.log("Driver update response:", response.data);
  
        dispatch({
          type: UPDATE_DRIVER_RESERVE, // <-- Define this action type in your reducer
          value: response.data,
        });
  
        return response;
      } catch (error) {
        console.error("Error updating driver:", error);
        throw error;
      }
    };
  };


  export const OptimizeReservations = (data) => {
    return async (dispatch) => {
      try {
        const token = getStorage('__token__');
        data['X-CSRF-TOKEN'] = token;
  
        const response = await TaskManagerRequest(`/fleet/optimize-reservations`, data);
  
        console.log(response.data);
  
        dispatch({
          type: OPTIMIZE_RESERVATIONS,
          value: response.data,
        });
  
        return response.data;
      } catch (error) {
        console.error("Error optimizing reservations:", error);
      }
    };
  };
  export const ApplyReschedule = (optimizedRides) => {
    return async (dispatch) => {
      try {
        const token = getStorage('__token__');
        data['X-CSRF-TOKEN'] = token;
  
        const response = await TaskManagerRequest(`/fleet/apply-optimized-schedule`, {optimizedRides,data});
  
        console.log(response.data);
  
        // dispatch({
        //   type: OPTIMIZE_RESERVATIONS,
        //   value: response.data,
        // });
  
        return response.data;
      } catch (error) {
        console.error("Error optimizing reservations:", error);
      }
    };
  };

  export const FleetgetCustomerList = (data) => {
  try {
    const user = getStorage("__user__", "object");
    const sortBy = data.sortBy ? data.sortBy : "date";
    const groupId = data.groupId ? data.groupId : 0;
    const page = data.page ? data.page : 1;
    const search = data.search ? data.search : "";

    data = { sortBy, groupId, page, search };

    return async (dispatch) => {
      const response = await TaskManagerRequest("/fleet/get/customers", data);
      dispatch({
        type: FLEET_GET_CUSTOMER_LIST,
        value: response.customers,
      });
    };
  } catch (error) {
    console.log("Error : ", error);
    return false;
  }
};
  